module.exports = __webpack_public_path__ + "img/bomb.18a0b149.svg";